import PaginationLayout from "../components/PaginationLayout";
import profile_placeholder from "../assets/images/profile_placeholder.png";
import { Link, useLocation, useMatch } from "react-router-dom";
import { useParams } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import henceforthApi from "../utils/henceforthApi";
import { GlobalContext } from "../context/Provider";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import moment from "moment";

export default () => {
    const match= useMatch("/suscriber/:page")
  const location = useLocation();
  let limit = 10;
  const { authState,handleError, handlePagination, handleFilter} = useContext(GlobalContext);
  const param = useParams();
  const newParam = new URLSearchParams(location.search);
  var query = new URLSearchParams(location.search);
  const [data, setData]=useState()
  const [loading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState("");
  henceforthApi.setToken(authState.access_token);

  const init = async () => {
    setLoading(true);
    let searchData = newParam.has("search") ? newParam.get("search") : null;
    setSearchData(searchData);
    try {
      let q = query.toString();
      let apiRes = await henceforthApi.Suscribe.listing(Number(match.params.page)-1 , limit, q);
      setData(apiRes)
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleError(error)
    }
  };

  useEffect(() => {
    init();
  }, [match.params.page, query.get("filter"), newParam.get("search")]);

  return (
    <>
      <div className="ibox animated fadeInRight">
        <div
          className="ibox-title d-flex align-items-center justify-content-between"
          style={{ color: "#000000" }}>
          <h5 style={{ fontSize: "16px" }} className="m-0 fw-bold">
            List of all Suscribers
          </h5>
        </div>
        <div className="ibox-content">
          <form
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <div class="input-group form-group">
              <input
                value={searchData}
                name="searchInput"
                onChange={(e) => {
                  handleFilter("search",e.target.value);
                }}
                placeholder="Search by Email"
                type="text"
                className="form-control form-control-sm "
                style={{ paddingBlock: "16px" }}
              />{" "}
              <span class="input-group-append">

              </span>
            </div>
          </form>
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr style={{ color: "#000000", fontSize: "14px" }}>
                  <th>Sr. No.</th>
                  <th>Email</th>
                  <th>Date & Time</th>
                </tr>
              </thead>
              <tbody>
                {!loading && !data?.subscribers?.length ? <tr><td colSpan={3} className="text-center"> <b>No Users Found </b> </td></tr>  : data?.subscribers.map((res, index) => (
                  <tr style={{ fontSize: "14px" }} key={res._id}>
                    <td>
                      {param.page === "0"
                        ? index + 1
                        : (param.page - 1) * limit + (index + 1)}
                      .
                    </td>
                    <td>{(res?.email == "" || res?.email == null) ?   "Not available" : res?.email}</td>
                    <td>{res?.created_at ? moment(Number(res?.created_at)).format("DD MMM YYYY , hh:mm a").toUpperCase() : "Not available"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <PaginationLayout
            count={Number(data?.count)}
            data={data?.subscribers}
            page={Number(match.params.page)}
            limit={Number(limit)}
            loading={loading}
            onPageChange={(val) => handlePagination(val)}
          />
        </div>
      </div>
    </>
  );
};